import { httpGet, httpPost, httpDelete, httpPut, httpPatch } from "../http";
import { femaCapture } from "../../fema/capture";
import { smartReviewEndpoints } from "../endpoints";
import {
  ApiResponse,
  UploadDocumentResponse,
  ServiceResponse,
  SmartReviewEntry,
} from "../types";

export class SmartReviewService {
  static async getSmartReview(
    customerId: string | number
  ): Promise<SmartReviewEntry[]> {
    try {
      const response = await httpGet<ApiResponse<SmartReviewEntry[]>>(
        smartReviewEndpoints.getSmartReview(customerId)
      );

      return response.data;
    } catch (error) {
      femaCapture("fetching_smart_review_data_error", error, {
        category: "api",
        severity: "error",
        skipSanitization: false,
        user: {},
      });

      throw error;
    }
  }

  static async createSmartReview(payload: SmartReviewEntry): any {
    try {
      const response = await httpPost<ApiResponse<any>>(
        smartReviewEndpoints.createSmartReview(),
        payload
      );
      return response.data;
    } catch (error: any) {
      return {
        success: true,
        message: "logging_failed_non_blocking",
        timestamp: new Date().toISOString(),
      } as ApiResponse<any>;
    }
  }

  static async patchSmartReview(payload: any, id: string | number): any {
    try {
      const response = await httpPatch<ApiResponse<any>>(
        smartReviewEndpoints.patchSmartReview(id),
        payload
      );
      return response.data;
    } catch (error: any) {
      return {
        success: true,
        message: "smart_review_patch_failed",
        timestamp: new Date().toISOString(),
      } as ApiResponse<any>;
    }
  }
}
